import {create} from 'zustand/react'

// Тип состояния хранилища.
export interface FooterStoreType {
    // Данные:

    // Видимость футера.
    visible: boolean

    // Состояние видимости ссылок навигации в футере.
    navLinks: boolean

    // API:

    // Задать видимость футера.
    setVisibility: (visible: boolean, navLinks?: boolean) => void

    // Задать видимость ссылок навигации в футере.
    setNavLinksVisibility: (visible: boolean) => void
}

// Хранилище настроек футера.
export const useFooterStore = create<FooterStoreType>(
    set => ({
        visible: true,
        navLinks: true,

        // API:

        setVisibility(visible: boolean, navLinks: boolean = true): void {
            set({
                visible,
                navLinks,
            })
        },

        setNavLinksVisibility(visible: boolean): void {
            set({
                navLinks: visible,
            })
        },
    })
)
